<template>
    <div class="main">
        <admin-navigation></admin-navigation>
        <div class="content-area">
            <div class="page-header">
                <div class="page-details">
                    <h2>{{ employeeDetails.first_name }} {{ employeeDetails.last_name }}</h2>
                    <ul class="breadcrumbs">
                        <li>
                            <router-link :to="'/dashboard'">Dashboard</router-link>
                        </li>
                        <li>
                            <router-link :to="'/employees'">Employees</router-link>
                        </li>
                        <li><a href="javascript:;" class="current">{{ employeeDetails.first_name }} {{ employeeDetails.last_name }}</a></li>
                    </ul>
                </div>
                <div class="actions">
                    <button class="btn btn-outline-primary" @click="deleteEmployee">
                        <svg width="21" height="23" viewBox="0 0 21 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.23999 5.88525H3.23999M3.23999 5.88525H19.24M3.23999 5.88525V19.8853C3.23999 20.4157 3.4507 20.9244 3.82578 21.2995C4.20085 21.6745 4.70956 21.8853 5.23999 21.8853H15.24C15.7704 21.8853 16.2791 21.6745 16.6542 21.2995C17.0293 20.9244 17.24 20.4157 17.24 19.8853V5.88525H3.23999ZM6.23999 5.88525V3.88525C6.23999 3.35482 6.4507 2.84611 6.82578 2.47104C7.20085 2.09597 7.70956 1.88525 8.23999 1.88525H12.24C12.7704 1.88525 13.2791 2.09597 13.6542 2.47104C14.0293 2.84611 14.24 3.35482 14.24 3.88525V5.88525M8.23999 10.8853V16.8853M12.24 10.8853V16.8853" stroke="#EB5757" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        Delete Employee
                    </button>
                </div>
            </div>
            <div class="multiple-sections align-items-start">
                <div class="section">
                    <div class="action d-flex">
                        <a href="#" style="margin-right:20px;" @click.prevent="editPassword">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.1665 2.40435C14.3854 2.18548 14.6452 2.01186 14.9312 1.89341C15.2171 1.77496 15.5236 1.71399 15.8332 1.71399C16.1427 1.71399 16.4492 1.77496 16.7352 1.89341C17.0211 2.01186 17.281 2.18548 17.4998 2.40435C17.7187 2.62321 17.8923 2.88305 18.0108 3.16902C18.1292 3.45499 18.1902 3.76148 18.1902 4.07101C18.1902 4.38054 18.1292 4.68704 18.0108 4.97301C17.8923 5.25897 17.7187 5.51881 17.4998 5.73768L6.24984 16.9877L1.6665 18.2377L2.9165 13.6543L14.1665 2.40435Z" stroke="#F32752" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            Update Password
                        </a>
                        <a href="#" @click.prevent="editEmployee">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.1665 2.40435C14.3854 2.18548 14.6452 2.01186 14.9312 1.89341C15.2171 1.77496 15.5236 1.71399 15.8332 1.71399C16.1427 1.71399 16.4492 1.77496 16.7352 1.89341C17.0211 2.01186 17.281 2.18548 17.4998 2.40435C17.7187 2.62321 17.8923 2.88305 18.0108 3.16902C18.1292 3.45499 18.1902 3.76148 18.1902 4.07101C18.1902 4.38054 18.1292 4.68704 18.0108 4.97301C17.8923 5.25897 17.7187 5.51881 17.4998 5.73768L6.24984 16.9877L1.6665 18.2377L2.9165 13.6543L14.1665 2.40435Z" stroke="#F32752" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            Edit Profile
                        </a>
                    </div>
                    <div class="user-profile">
                        <div class="user-basicinfo">
                            <img v-if="employeeDetails.image != ''" :src="employeeDetails.image" />
                            <img v-if="employeeDetails.image == ''" :src="base_url + 'admin/img/user-avatar.jpeg'" />
                            <h4>{{ employeeDetails.first_name }} {{ employeeDetails.last_name }}</h4>
                            <label for="">{{ (employeeDetails.status) ? "Active" : "In-active" }}</label>
                        </div>
                        <div class="user-detailedinfo">
                            <div class="userInfoDetails">
                                <div class="user__info" v-if="employeeDetails.external_id != '' && employeeDetails.external_id != null">
                                    <img :src="base_url + '/admin/img/designation.svg'" />
                                    <p>{{ employeeDetails.external_id }}</p>
                                </div>
                                <div class="user__info">
                                    <img :src="base_url + '/admin/img/designation.svg'" />
                                    <p>{{ employeeDetails.designation }}</p>
                                </div>
                                <div class="user__info">
                                    <img :src="base_url + '/admin/img/email.svg'" />
                                    <p>{{ employeeDetails.email }}</p>
                                </div>
                                <div class="user__info">
                                    <img :src="base_url + '/admin/img/call.svg'" />
                                    <p>{{ employeeDetails.phone }}</p>
                                </div>
                                <div class="user__info" v-bind:class="{'feature--inactive': !employeeDetails.multi_location}">
                                    <img :src="base_url + '/admin/img/multi-location.svg'" />
                                    <p>Multi-Location Checkin / Checkout</p>
                                </div>
                                <div class="user__info" v-bind:class="{'feature--inactive': !employeeDetails.static_qr}">
                                    <img :src="base_url + '/admin/img/qr_icon.svg'" />
                                    <p>QR</p>
                                </div>
                                <div class="user__info" v-bind:class="{'feature--inactive': !employeeDetails.gps_checkin}">
                                    <img :src="base_url + '/admin/img/Badge.svg'" />
                                    <p>Remote</p>
                                </div>
                                <div class="user__info" v-bind:class="{'feature--inactive': !employeeDetails.qr_card}">
                                    <img :src="base_url + '/admin/img/Badge.svg'" />
                                    <p>Kiosk</p>
                                </div>
                                <div class="user__info">
                                    <img :src="base_url + '/admin/img/Dept.svg'" />
                                    <p>{{ employeeDetails.department }}</p>
                                </div>
                                <div class="user__info" v-bind:class="{'feature--inactive': !employeeDetails.block_attendance}">
                                    <img :src="base_url + '/admin/img/attendance.png'" />
                                    <p>Block Attendance</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="section qr" id="employee_qrcode">
                    <vue-qrcode :value="employeeDetails.qr_code" :options="{ width: 200 }"></vue-qrcode>
                    <div class="d-flex">
                        <a href="#" @click.prevent="regenerateQrCode">
                            <img :src="base_url + '/admin/img/Regenerate.svg'" />
                        </a>
                        <a :href="qrCodeHref" :download="employeeDetails.first_name + '_' + employeeDetails.last_name + '_qrcode.jpg'" @click="downloadQrcode">
                            <img :src="base_url + '/admin/img/download.svg'" />
                        </a>
                    </div>
                </div>
            </div>
            <!-- In case tags have been added -->
            <div class="section" v-if="!emptyTagsState">
                <div class="section__header">
                    <div class="section__title">
                        <h5>Tags</h5>
                        <p>Tags related to this user</p>
                    </div>
                    <div class="section__actions">
                        <a href="#" @click.prevent="manageTags">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.1665 2.40435C14.3854 2.18548 14.6452 2.01186 14.9312 1.89341C15.2171 1.77496 15.5236 1.71399 15.8332 1.71399C16.1427 1.71399 16.4492 1.77496 16.7352 1.89341C17.0211 2.01186 17.281 2.18548 17.4998 2.40435C17.7187 2.62321 17.8923 2.88305 18.0108 3.16902C18.1292 3.45499 18.1902 3.76148 18.1902 4.07101C18.1902 4.38054 18.1292 4.68704 18.0108 4.97301C17.8923 5.25897 17.7187 5.51881 17.4998 5.73768L6.24984 16.9877L1.6665 18.2377L2.9165 13.6543L14.1665 2.40435Z" stroke="#F32752" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                            Edit Tags
                        </a>
                    </div>
                </div>
                <div class="section__body">
                    <div class="tags">
                        <label for="" class="tag" v-for="tag in employeeTags">{{ tag.name }}</label>
                    </div>
                </div>
            </div>
            <!-- No Location for this employee -->
            <div class="section" v-if="emptyTagsState">
                <div class="section__body">
                    <div class="empty-state mb-4">
                        <img :src="base_url + '/admin/img/noTags.svg'" />
                        <h5>No Tag Added</h5>
                        <p>
                            Looks like there are no tags added yet <br />
                            Click below to start adding tags
                        </p>
                        <a href="#" class="btn btn-primary" @click.prevent="manageTags"> + Add Tags</a>
                    </div>
                </div>
            </div>
            <!-- In case location have been added -->
            <div class="section" v-if="!emptyLocationsState">
                <div class="section__header">
                    <div class="section__title">
                        <h5>Locations</h5>
                        <p>Locations related to this user</p>
                    </div>
                    <div class="section__actions">
                        <a href="#" @click.prevent="manageLocations">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.1665 2.40435C14.3854 2.18548 14.6452 2.01186 14.9312 1.89341C15.2171 1.77496 15.5236 1.71399 15.8332 1.71399C16.1427 1.71399 16.4492 1.77496 16.7352 1.89341C17.0211 2.01186 17.281 2.18548 17.4998 2.40435C17.7187 2.62321 17.8923 2.88305 18.0108 3.16902C18.1292 3.45499 18.1902 3.76148 18.1902 4.07101C18.1902 4.38054 18.1292 4.68704 18.0108 4.97301C17.8923 5.25897 17.7187 5.51881 17.4998 5.73768L6.24984 16.9877L1.6665 18.2377L2.9165 13.6543L14.1665 2.40435Z" stroke="#F32752" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                            Edit Locations
                        </a>
                    </div>
                </div>
                <div class="section__body">
                    <div class="tags">
                        <label for="" class="tag" v-for="location in employeeLocations">{{ location.name }}</label>
                    </div>
                </div>
            </div>
            <!-- No Location for this employee -->
            <div class="section" v-if="emptyLocationsState">
                <div class="section__body">
                    <div class="empty-state mb-4">
                        <img :src="base_url + '/admin/img/noTags.svg'" />
                        <h5>No Location Added</h5>
                        <p>
                            Looks like there are no location added yet <br />
                            Click below to start adding locations
                        </p>
                        <a href="#" class="btn btn-primary" @click.prevent="manageLocations"> + Add Location</a>
                    </div>
                </div>
            </div>
            <div class="searchbar mb-3" v-if="!emptyAttendanceState">
                <div class="filters filters--center mt-0">
                    <div class="filter">
                        <div class="filter__header">
                            <span class="filter__label">Location</span><span class="filter__value"></span>
                            <span class="filter__icon">
                                <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.844173 1.09143L4.66134 4.9086L8.47852 1.09143" stroke="#4F4F4F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                </svg>
                            </span>
                        </div>
                        <div class="filter__dropdown shadow">
                            <div class="input-checkbox locations-filter" data-active="false" v-for="location in locations" :data-id="location.id" @click="setCheckedFilteredLocations">
                                <input type="checkbox" name="location_id[]" :value="location.id" v-model="filterForm.locations" />
                                <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect class="border" x="0.75" y="1.65929" width="16.4093" height="16.4093" rx="1.25" stroke="url(#paint0_linear)" stroke-width="1.5"></rect>
                                    <path class="checkmark" d="M13.6668 6.45709L7.25016 12.8738L4.3335 9.95709" stroke="url(#paint1_linear)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                    <defs>
                                        <linearGradient id="paint0_linear" x1="3.73129" y1="21.2333" x2="15.6945" y2="0.909877" gradientUnits="userSpaceOnUse">
                                            <stop stop-color="#EE0979"></stop>
                                            <stop offset="1" stop-color="#FF6A00"></stop>
                                        </linearGradient>
                                        <linearGradient id="paint1_linear" x1="6.27804" y1="13.7389" x2="9.68752" y2="5.31402" gradientUnits="userSpaceOnUse">
                                            <stop stop-color="#EE0979"></stop>
                                            <stop offset="1" stop-color="#FF6A00"></stop>
                                        </linearGradient>
                                    </defs>
                                </svg>
                                <label for="sample1">{{ location.name }}</label>
                            </div>
                        </div>
                    </div>
                    <div class="filter">
                        <div class="filter__header">
                            <VueDatePicker v-model="filterForm.date" :color="admin_color" />
                        </div>
                    </div>
                    <input type="hidden" name="date" id="date" value="">
                    <button type="button" class="btn filter-button" @click="applyFilter">Filter</button>
                    <a class="reset-filter me-3" @click.prevent="resetFilter" href="#"> Reset Filter</a>
                    <button @click="createAttendance" class="btn btn-success">+ Add Attendance</button>
                </div>
            </div>
            <div class="section" v-if="!emptyAttendanceState">
                <data-table :ajax="attendanceAjax" :columns="attendanceColumns" :order="0"></data-table>
            </div>
            <div class="section" v-if="emptyAttendanceState">
                <div class="section__body">
                    <div class="empty-state mb-4">
                        <img :src="base_url + '/admin/img/noActivity.svg'" />
                        <h5>No Activity Yet</h5>
                        <p>
                            Looks like there are no users records <br />
                            Kindly Create one to show data.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="manageEmployeeModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Edit Details</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <form action="#" id="manageEmployeeForm" @submit.prevent="updateEmployee">
                        <div class="modal-body">
                            <div class="form-group">
                                <label for="">Uploaded Image</label>
                                <img v-if="employeeDetails.image != ''" :src="employeeForm.image" class="w-25" />
                                <img v-if="employeeDetails.image == ''" :src="base_url + 'admin/img/user-avatar.jpeg'" class="w-25" />
                            </div>
                            <div class="form-group">
                                <label for="">Upload User Image</label>
                                <input type="file" class="form-control" name="image" />
                            </div>
                            <div class="form-group">
                                <label for="">External ID</label>
                                <input type="text" class="form-control" name="external_id" v-model="employeeForm.external_id" />
                            </div>
                            <div class="form-group">
                                <label for="">First Name</label>
                                <input type="text" class="form-control" name="first_name" v-model="employeeForm.first_name" required />
                            </div>
                            <div class="form-group">
                                <label for="">Last Name</label>
                                <input type="text" class="form-control" name="last_name" v-model="employeeForm.last_name" required />
                            </div>
                            <div class="form-group">
                                <label for="">Email ID</label>
                                <input type="email" class="form-control" name="email" readonly="" v-model="employeeForm.email" required />
                            </div>
                            <div class="form-group">
                                <label for="">Phone Number</label>
                                <input type="text" class="form-control" name="phone" v-model="employeeForm.phone" required />
                            </div>
                            <div class="form-group">
                                <label for="">Designation</label>
                                <input type="text" class="form-control" name="designation" v-model="employeeForm.designation" required />
                            </div>
                            <div class="form-group">
                                <label for="">Department</label>
                                <input type="text" class="form-control" name="department" v-model="employeeForm.department" required />
                            </div>
                            <div class="form-group">
                                <label for="">Settings</label>
                                <div class="form-check">
                                    <input class="form-check-input" name="status" type="checkbox" v-model="employeeForm.status" value="1" id="status" />
                                    <label class="form-check-label" for="status"> Active </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" name="multi_location" type="checkbox" v-model="employeeForm.multi_location" value="1" id="multi_location" />
                                    <label class="form-check-label" for="multi_location"> Multi-Location Checkin / Checkout </label>
                                </div>
                                   <div class="form-check">
                                    <input class="form-check-input" name="block_attendance" type="checkbox" v-model="employeeForm.block_attendance" value="1" id="block_attendance" />
                                    <label class="form-check-label" for="block_attendance"> Block Attendance </label>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="">Allowed Attendance Types</label>
                                <div class="form-check" v-if="$root.packageInfo.static_qr">
                                    <input class="form-check-input" name="static_qr" v-model="employeeForm.static_qr" type="checkbox" value="1" id="static_qr" />
                                    <label class="form-check-label" for="static_qr"> QR </label>
                                </div>
                                <div class="form-check"  v-if="$root.packageInfo.gps_checkin">
                                    <input class="form-check-input" name="gps_checkin" v-model="employeeForm.gps_checkin" type="checkbox" value="1" id="gps_checkin" />
                                    <label class="form-check-label" for="gps_checkin"> Remote </label>
                                </div>
                                <div class="form-check" v-if="$root.packageInfo.qr_card">
                                    <input class="form-check-input" name="qr_card" v-model="employeeForm.qr_card" type="checkbox" value="1" id="qr_card" />
                                    <label class="form-check-label" for="qr_card"> Kiosk </label>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="submit" class="btn btn-primary">Save changes</button>
                            <button type="button" class="btn" data-bs-dismiss="modal">Cancel</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <!-- Update password -->
        <div class="modal fade" id="manageEmployeePasswordModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Update Password</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <form action="#" id="manageEmployeePasswordForm" @submit.prevent="updatePassword">
                        <div class="modal-body">                            
                            <div class="form-group">
                                <label for="">New Password</label>
                                <input type="password" class="form-control" name="password" v-model="employeePasswordForm.password" required />
                            </div>
                            <div class="form-group">
                                <label for="">Confirm Password</label>
                                <input type="password" class="form-control" name="password_confirmation" v-model="employeePasswordForm.password_confirmation" required />
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="submit" class="btn btn-primary">Save changes</button>
                            <button type="button" class="btn" data-bs-dismiss="modal">Cancel</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <!-- Edit Tags -->
        <div class="modal fade" id="manageTagsModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Edit Tags</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="tags__listing">
                            <div class="tags__entry" v-for="tag in allTags">
                                <h6>{{ tag.name }}</h6>
                                <div class="switch" :data-active="tag.exists" @click="switchTag(tag)">
                                    <input type="checkbox" :value="tag.id" />
                                    <div class="switch__wrapper">
                                        <div class="switch__toggle"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-info" data-bs-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Edit Tags -->
        <div class="modal fade" id="manageLocationsModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel1">Edit Locations</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="locations__listing">
                            <div class="tags__entry" v-for="location in locations">
                                <h6>{{ location.name }}</h6>
                                <div class="switch" :data-active="location.exists" @click="switchLocation(location)">
                                    <input type="checkbox" :value="location.id" name="locations[]" />
                                    <div class="switch__wrapper">
                                        <div class="switch__toggle"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-info" data-bs-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Attendance CRUD -->
        <div class="modal fade" id="manageAttendanceModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" v-show="!editAttendanceMode">Add attendance</h5>
                        <h5 class="modal-title" v-show="editAttendanceMode">Edit attendance</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <form action="#" id="manageAttendanceForm" @submit.prevent="validateAttendanceForm" enctype="multipart/form-data">
                        <div class="modal-body">
                            <div class="form-group" :class="{ 'form-group--error': $v.attendanceForm.location_id.$error }">
                                <label for="">Location</label>
                                <select name="location_id" v-model="attendanceForm.location_id" class="form-control">
                                    <option value="">Choose location</option>
                                    <option v-for="location in locations" :value="location.id">{{ location.name }}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label for="">Action Type</label>
                                <input type="radio" name="action_type" value="1" v-model="attendanceForm.action_type" /> Check In
                                <input type="radio" name="action_type" value="0" v-model="attendanceForm.action_type" /> Check Out
                            </div>
                            <div class="form-group">
                                <label for="">Attendance Type</label>
                                <input type="radio" name="attendance_type" value="static_qr" v-model="attendanceForm.attendance_type" /> QR
                                <input type="radio" name="attendance_type" value="gps_checkin" v-model="attendanceForm.attendance_type" /> Remote
                                <input type="radio" name="attendance_type" value="qr_card" v-model="attendanceForm.attendance_type" /> Kiosk
                                <input type="radio" name="attendance_type" value="admin" v-model="attendanceForm.attendance_type" /> Admin
                            </div>
                            <div class="form-group" :class="{ 'form-group--error': $v.attendanceForm.action_date.$error }">
                                <label for="">Action Date</label>
                                <VueDatePicker v-model="attendanceForm.action_date" format="YYYY-MM-DD" :color="admin_color" />
                            </div>
                            <div class="form-group" :class="{ 'form-group--error': $v.attendanceForm.action_time.$error }">
                                <label for="">Action Time</label>
                                <input type="time" class="form-control" v-model="attendanceForm.action_time" />
                                <p class="text-muted">Time should be added in UTC.</p>
                            </div>
                            <div class="form-group">
                                <label for="">Latitude</label>
                                <input type="text" class="form-control" v-model="attendanceForm.latitude" />
                            </div>
                            <div class="form-group">
                                <label for="">Longitude</label>
                                <input type="text" class="form-control" v-model="attendanceForm.longitude" />
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="submit" class="btn btn-primary">Save</button>
                            <button type="button" class="btn" data-bs-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-danger" @click.prevent="deleteAttendance" v-show="editAttendanceMode">Delete</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
export default {
    data() {
        return {
            employee_id: '',
            qrCodeHref: '',
            employeeDetails: {},
            allTags: {},
            employeeTags: {},
            employeeLocations: {},
            employeeAttendance: {},
            emptyTagsState: false,
            emptyAttendanceState: false,
            employeeForm: new Form({
                external_id: '',
                first_name: '',
                last_name: '',
                designation: '',
                email: '',
                phone: '',
                department: '',
                static_qr: 0,
                gps_checkin: 0,
                qr_card: 0,
                multi_location: 0,
                block_attendance: 0,
                status: 1,
                image: ''
            }),
            employeePasswordForm: new Form({
                id: 0,
                password: '',
                password_confirmation: ''
            }),
            filterForm: new Form({
                date: null,
                locations: [],
            }),
            locations: {},
            attendanceAjax: {},
            attendanceColumns: [],
            emptyLocationsState: false,
            editAttendanceMode: false,
            attendanceForm: new Form({
                id: "",
                employee_id: "",
                location_id: "",
                action_type: 1,
                attendance_type: "static_qr",
                action_date: null,
                action_time: "",
                latitude: "",
                longitude: "",
                _method: "post"
            }),
        }
    },
    validations: {
        attendanceForm: {
            location_id: {required}, action_date: {required}, action_time: {required}
        }
    },
    created() {
        this.employee_id = this.$route.params.slug;
        this.loadDataTableDetails();
    },
    mounted() {
        this.getEmployeeDetails();
        this.loadAllOrganizationsTags();
        this.loadEmployeeTags();
        this.getLocations();
        this.loadEmployeeLocations();
        this.viewAttendance();
    },
    methods: {
        getEmployeeDetails() {
            axios.get(`/api/admin/employees/${this.employee_id}`)
                .then(response => {
                    this.employeeDetails = response.data.data;
                });
        },
        regenerateQrCode() {
            axios.get(`/api/admin/employees/regenerate-qrcode/${this.employee_id}`)
                .then(response => {
                    this.employeeDetails.qr_code = response.data.data.qr_code;
                    Toast.fire({ icon: 'success', title: response.data.message });
                });
        },
        downloadQrcode(el) {
            let canvas = $("#employee_qrcode canvas");
            let image = canvas[0].toDataURL("image/jpg");
            this.qrCodeHref = image;
        },
        editEmployee() {
            this.employeeForm.fill(this.employeeDetails);
            $("#manageEmployeeModal").modal("show");
        },
        updateEmployee() {
            let applyUpdate = this.changeMultiLocationStatus();
            if(applyUpdate) {
                let formData = new FormData($("#manageEmployeeForm")[0]);
                formData.append("_method", "put");
                axios({
                    method: "post",
                    url: `/api/admin/employees/${this.employee_id}`,
                    data: formData,
                }).then((response) => {
                    if (response.data.status) {
                        Toast.fire({ icon: 'success', title: response.data.message });
                        $("#manageEmployeeModal").modal("hide");
                        this.getEmployeeDetails();
                    } else {
                        Toast.fire({ icon: 'error', title: response.data.message });
                    }
                }, (error) => {
                    console.log(error)
                });
            } else {
                $.alert({
                    title: "Warning!",
                    content: "Employee should have access to one location only <br /> in order to deactivate Multi-location option."
                });
            }
            
        },
        editPassword() {
            this.employeePasswordForm.clear();
            this.employeePasswordForm.reset();
            $("#manageEmployeePasswordModal").modal("show");
        },
        updatePassword() {
            this.employeePasswordForm.id = this.employee_id;
            axios({
                method: "post",
                url: `/api/admin/employees/update-password`,
                data: this.employeePasswordForm,
            }).then((response) => {
                if (response.data.status) {
                    Toast.fire({ icon: 'success', title: response.data.message });
                    $("#manageEmployeePasswordModal").modal("hide");
                } else {
                    Toast.fire({ icon: 'error', title: response.data.message });
                }
            }, (error) => {
                console.log(error)
            });
        },
        changeMultiLocationStatus() {
            let current_locations_count = Object.keys(this.employeeLocations).length;
            let multi_location = $("#multi_location").val();
            if(!$("#multi_location").is(":checked")) {
                if(current_locations_count > 1) {
                    return false;
                }
            }
            return true;            
        },
        deleteEmployee() {
            let employee_id = this.employee_id;
            $.confirm({
                title: 'Confirmation!',
                content: 'Are you sure to delete this employee?',
                buttons: {
                    confirm: {
                        btnClass: 'btn-red',
                        keys: ['enter'],
                        action: function() {
                            axios({
                                method: "delete",
                                url: `/api/admin/employees/${employee_id}`,
                            }).then((response) => {
                                Toast.fire({ icon: 'success', title: response.data.message });
                                this.$router.push('/employees');
                            }, (error) => {
                                console.log(error)
                            });
                        }
                    },
                    cancel: function() {
                        Toast.fire({ icon: 'success', title: "Cancelled." });
                    }
                }
            });
        },

        loadAllOrganizationsTags() {
            axios.get(`/api/admin/tags/employee/${this.employee_id}`)
                .then(response => {
                    this.allTags = response.data.data;
                });
        },
        loadEmployeeTags() {
            axios.get(`/api/admin/employees/tags/${this.employee_id}`)
                .then(response => {
                    this.employeeTags = response.data.data;
                    if (Object.keys(response.data.data).length > 0) {
                        this.emptyTagsState = false;
                    } else {
                        this.emptyTagsState = true;
                    }
                });
        },
        loadEmployeeLocations() {
            axios.get(`/api/admin/employees/locations/${this.employee_id}`)
                .then(response => {
                    this.employeeLocations = response.data.data;
                    if (Object.keys(response.data.data).length > 0) {
                        this.emptyLocationsState = false;
                    } else {
                        this.emptyLocationsState = true;
                    }
                });
        },
        manageTags() {
            $("#manageTagsModal").modal("show");
        },
        manageLocations() {
            $("#manageLocationsModal").modal("show");
        },
        switchTag(tag) {
            axios.get(`/api/admin/employees/${this.employee_id}/manage-tag/${tag.id}`)
                .then(response => {
                    Toast.fire({ icon: 'success', title: response.data.message });
                    this.loadAllOrganizationsTags();
                    this.loadEmployeeTags();
                });
        },
        switchLocation(location) {
            axios.get(`/api/admin/employees/${this.employee_id}/manage-location/${location.id}`)
                .then(response => {
                    if(response.data.status) {
                        Toast.fire({ icon: 'success', title: response.data.message });
                    } else {
                        Toast.fire({ icon: 'error', title: response.data.message });
                    }
                    this.getLocations();
                    this.loadEmployeeLocations();                    
                });
        },
        getLocations() {
            axios.get(`/api/admin/locations/employee/${this.employee_id}`).then(response => {
                this.locations = response.data.data;
            });
        },
        loadDataTableDetails() {
            this.attendanceAjax = {
                url: `/api/admin/employees/attendance/${this.employee_id}?location_id=${this.filterForm.locations}&date=${this.filterForm.date}`,
                method: "GET",
                headers: {
                    'X-Api-Key': `Bearer ${localStorage.getItem("admin_auth")}`
                },
            };

            this.attendanceColumns = [
                { name: 'action_date', data: 'action_date', orderable: true, searchable: true },
                { name: 'Action', data: 'action_type', orderable: true, searchable: true },
                { name: 'Time', data: 'action_time', orderable: true, searchable: true },
                { name: 'Type', data: 'attendance_type', orderable: true, searchable: true },
                { name: 'Location', data: 'location_name', orderable: true, searchable: true },
                {
                    name: 'Actions',
                    data: null,
                    render(data, type, row, meta) {
                        return `<div class="action-bar">
                                <a href="javascript:;" data-id="${data.id}" class="view-attendance-details"><img src="/admin/img/view.svg" /></a>
                            </div>`;
                    },
                },
            ];
        },
        applyFilter() {
            this.refreshDataTable();
        },
        resetFilter() {
            this.filterForm.clear();
            this.filterForm.reset();

            $(".locations-filter").attr("data-active", "false").change();

            $(".filter__value").html("");

            this.refreshDataTable();
        },
        refreshDataTable() {
            // Replacing old attendance ajax variable according to filters.
            this.attendanceAjax = {
                url: `/api/admin/employees/attendance/${this.employee_id}?location_id=${this.filterForm.locations}&date=${this.filterForm.date}`,
                method: "GET",
                headers: {
                    'X-Api-Key': `Bearer ${localStorage.getItem("admin_auth")}`
                },
            };

            let options = {
                ajax: this.attendanceAjax,
                scrollY: false,
                scrollX: true,
                serverSide: true,
                searching: false,
                dom: '<"top">rt<"bottom"<"left-actions"li>p><"clear">',
                columnDefs: [],
                select: {
                    style: "os",
                    selector: "td:first-child",
                },
                order: [[0, "desc"]],
                columns: this.attendanceColumns,
            };

            $(".user-datatable").DataTable().destroy();

            $(".user-datatable").DataTable(options).draw();
        },
        setCheckedFilteredLocations(e) {
            let currentTargetValues = e.currentTarget;
            let checkedLocations = this.filterForm.locations;
            if (currentTargetValues.getAttribute("data-active") && currentTargetValues.getAttribute("data-id")) {
                if (currentTargetValues.getAttribute("data-active") == "false") {
                    // Means checked as it's getting the values before design action
                    checkedLocations.push(currentTargetValues.getAttribute("data-id"));
                } else {
                    var index = checkedLocations.indexOf(currentTargetValues.getAttribute("data-id"));
                    if (index !== -1) {
                        checkedLocations.splice(index, 1);
                    }
                }
            }
            this.filterForm.locations = checkedLocations;
        },

        validateAttendanceForm() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                if(!this.$v.required) {
                    $.alert("Please fill all requried fields.");
                }
            } else {
                if(this.editAttendanceMode) {
                    this.updateAttendance();
                } else {
                    this.storeAttendance();
                }
            }
        },
        createAttendance() {
            $("#manageAttendanceForm .form-group").removeClass("form-group--error");
            this.editAttendanceMode = false;
            this.attendanceForm.clear();
            this.attendanceForm.reset();
            $("#manageAttendanceModal").modal("show");
        },
        storeAttendance() {
            this.attendanceForm.employee_id = this.employee_id;
            axios({
                method: "post",
                url: "/api/admin/attendances",
                data: this.attendanceForm
            }).then((response) => {
                if (response.data.status) {
                    $("#manageAttendanceModal").modal("hide");
                    Toast.fire({ icon: 'success', title: response.data.message });
                    this.refreshDataTable();
                } else {
                    Toast.fire({ icon: 'error', title: response.data.message });
                }
            }, (error) => {
                console.log(error)
            });
        },
        viewAttendance() {
            let $this = this;
            this.editAttendanceMode = true;
            this.attendanceForm.clear();
            this.attendanceForm.reset();
            $(document).on("click", ".view-attendance-details", function(e) {
                e.preventDefault();
                let id = $(this).data("id");
                axios.get(`/api/admin/attendances/${id}`).then(response => {
                    let attendance_details = response.data.data;
                    $this.attendanceForm.fill(attendance_details);
                });
                $("#manageAttendanceModal").modal("show");
            });
        },
        updateAttendance() {
            this.attendanceForm._method = "PUT";
            axios({
                method: "post",
                url: `/api/admin/attendances/${this.attendanceForm.id}`,
                data: this.attendanceForm
            }).then((response) => {
                if (response.data.status) {
                    $("#manageAttendanceModal").modal("hide");
                    Toast.fire({ icon: 'success', title: response.data.message });
                    this.refreshDataTable();
                } else {
                    Toast.fire({ icon: 'error', title: response.data.message });
                }
            }, (error) => {
                console.log(error)
            });
        },
        deleteAttendance() {
            let $this = this;
            $.confirm({
                title: 'Confirmation!',
                content: 'Are you sure to delete this attendance record?',
                buttons: {
                    confirm: {
                        btnClass: 'btn-red',
                        keys: ['enter'],
                        action: function() {
                            axios({
                                method: "delete",
                                url: `/api/admin/attendances/${$this.attendanceForm.id}`,
                            }).then((response) => {
                                if (response.data.status) {
                                    $("#manageAttendanceModal").modal("hide");
                                    Toast.fire({ icon: 'success', title: response.data.message });
                                    $this.refreshDataTable();
                                } else {
                                    Toast.fire({ icon: 'error', title: response.data.message });
                                }
                            }, (error) => {
                                console.log(error)
                            });
                        }
                    },
                    cancel: function() {
                        Toast.fire({ icon: 'success', title: "Cancelled." });
                    }
                }
            });
        },
    },
}

</script>
